import { Link, useLocation } from "react-router-dom";
import { ArrowRight, ArrowDown } from "lucide-react";
import { ROUTE_WAITLIST } from "@/lib/brand";
import { STATUS_LAUNCH } from "@/lib/status";

// Unterkante im Stil des Absperrbands auf der Kontaktseite: Markenverlauf mit
// dunklen Schrägstreifen, hier nur wenige Pixel hoch.
const EDGE = {
  backgroundImage:
    "repeating-linear-gradient(-45deg, rgb(var(--navy-950)) 0 3px, transparent 3px 7px), linear-gradient(90deg, #FF6B00, #007AFF)",
};

const LINK =
  "group inline-flex items-center gap-1.5 shrink-0 whitespace-nowrap font-semibold text-white/90 hover:text-white transition-colors duration-300";

/**
 * Schmale Leiste über der Navigation auf allen Seiten: Start der Plattform
 * und Weg zur Warteliste. Gehört zum fixierten Kopf, die Höhe kommt aus
 * --bar-h (src/index.css). Bewusst ruhig und nicht wegklickbar. Ab md steht
 * der Inhalt mittig über der Navigation, nicht über der ganzen Breite.
 */
export const StartBar = () => {
  const { pathname } = useLocation();
  const onWaitlist = pathname === ROUTE_WAITLIST;

  return (
    <div data-testid="start-bar" className="relative h-bar bg-navy-900 md:pl-20">
      <div className="h-full pb-[3px] px-4 sm:px-6 flex items-center justify-center gap-3 sm:gap-5 text-xs sm:text-[13px]">
        <p className="min-w-0 flex items-center gap-2.5 text-white/55">
          <span
            aria-hidden="true"
            className="hidden sm:block w-1.5 h-1.5 shrink-0 rounded-full bg-brand-orange"
          />
          <span className="truncate">
            <span className="sm:hidden">Start {STATUS_LAUNCH.in}</span>
            <span className="hidden sm:inline lg:hidden">
              MatchGate startet {STATUS_LAUNCH.in}
            </span>
            <span className="hidden lg:inline">
              MatchGate startet {STATUS_LAUNCH.in}, die Warteliste ist offen.
            </span>
          </span>
        </p>

        {onWaitlist ? (
          <a href="#formular" data-testid="start-bar-link" className={LINK}>
            Zum Formular
            <ArrowDown className="w-3.5 h-3.5 group-hover:translate-y-0.5 transition-transform duration-300" />
          </a>
        ) : (
          <Link to={ROUTE_WAITLIST} data-testid="start-bar-link" className={LINK}>
            Platz vormerken
            <ArrowRight className="w-3.5 h-3.5 group-hover:translate-x-0.5 transition-transform duration-300" />
          </Link>
        )}
      </div>
      <div
        aria-hidden="true"
        className="absolute inset-x-0 bottom-0 h-[3px] opacity-80"
        style={EDGE}
      />
    </div>
  );
};
